import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Pipe({
  name: 'bypassSanitizer'
})
export class BypassSanitizerPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) { }
  public transform(url: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

}
